import { Colors, UTMMedium, UTMParams, UTMSources, utmParamsByAttrsType } from '@sigma-frontend-libs/commons'

import { buttonModes, components, sizes } from '@/utils'

import button from '@/components/button'
import buttonCopy from '@/components/button/copy'
import tag from '@/components/tag'

function renderURL(h) {
  let urlGridColumns = '1fr'
  if (this.viewport.breakpoint.mdUp) {
    urlGridColumns = '130px 1fr'
  }

  let urlError
  if (this.url && !this.urlIsValid) {
    urlError = 'false'
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { gridTemplateColumns: urlGridColumns }
    },
    [
      h(
        components.select,
        {
          props: {
            value: this.protocol,
            label: this.getTranslate('utm.labels.protocol'),
            items: [ 'https://', 'http://' ],
            dense: true,
            required: true,
            details: false
          },
          on: {
            input: event => {
              this.protocol = event
            }
          }
        }
      ),
      h(
        components['text-field'],
        {
          props: {
            value: this.url,
            label: this.getTranslate('utm.labels.url'),
            error: urlError,
            dense: true,
            details: false,
            clearable: true,
            required: true
          },
          on: {
            input: event => {
              this.url = event
            }
          }
        }
      )
    ]
  )
}

function renderSource(h, source) {
  let sourceMode = buttonModes.flat
  let sourceColor
  if (this.source === source) {
    sourceMode = buttonModes.filled
    sourceColor = Colors.primary
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`utm.labels.${source}`),
        size: sizes.small,
        mode: sourceMode,
        color: sourceColor
      },
      on: {
        click: () => {
          this.source = source
        }
      }
    }
  )
}
function renderSources(h) {
  return h(
    'div',
    {
      class: 'faic fw grid-gap--8'
    },
    [
      Object.values(UTMSources).map(source => {
        return renderSource.call(this, h, source)
      })
    ]
  )
}

function renderParam(h, param) {
  let component = components['text-field']
  if (param === UTMParams.utm_medium) {
    component = components.select
  }
  const required = utmParamsByAttrsType.required.includes(param)

  return h(
    component,
    {
      props: {
        value: this.params[param],
        label: this.getTranslate(`utm.labels.${param}`, { param }),
        hint: this.getTranslate(`utm.hints.${this.source}.${param}`),
        items: Object.values(UTMMedium),
        dense: true,
        combobox: true,
        clearable: component === components['text-field'],
        required,
        mask: /^[^а-яё]+$/iu
      },
      key: param,
      on: {
        input: event => {
          this.params[param] = event
        }
      }
    }
  )
}
function renderReferenceDialog(h, param) {
  let referenceMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    referenceMaxWidth = 600
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showReference[param],
        title: this.getTranslate(`utm.titles.${param}`, { param }),
        maxWidth: referenceMaxWidth
      },
      on: {
        input: event => {
          this.showReference[param] = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'px-3',
          domProps: {
            innerHTML: this.getTranslate(`utm.references.${param}`)
          }
        }
      ),
      h(
        'div',
        {
          class: 'pa-2 faic fjcfe grid-gap--8',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.showReference[param] = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderReferenceButton(h, param) {
  return h(
    button,
    {
      props: {
        iconSVG: 'question-mark',
        mode: buttonModes.flat,
        color: Colors.secondary,
        tooltip: this.getTranslate('utm.tooltips.reference', { param })
      },
      on: {
        click: () => {
          this.showReference[param] = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderReferenceDialog.call(this, h, param)
        }
      }
    }
  )
}
function renderParams(h) {
  const params = utmParamsByAttrsType

  let paramsGridColumns = '1fr'
  if (this.viewport.breakpoint.mdUp) {
    paramsGridColumns = 'repeat(2, 1fr)'
  }

  return h(
    'div',
    {
      class: 'grid',
      style: { gridTemplateColumns: paramsGridColumns }
    },
    [
      Object.keys(params).map(key => {
        return h(
          components.card,
          {
            class: 'grid grid-gap--12 pt-3 pb-2 px-2',
            props: {
              title: this.getTranslate(`utm.titles.params.${key}`),
              dashed: key === 'optional',
              rounded: true,
              outline: true
            }
          },
          [
            Object.keys(params[key]).map(param => {
              return h(
                'div',
                {
                  class: 'grid grid-gap--8',
                  style: { gridTemplateColumns: '1fr auto' }
                },
                [
                  renderParam.call(this, h, params[key][param]),
                  renderReferenceButton.call(this, h, params[key][param])
                ]
              )
            })
          ]

        )
      })
    ]
  )
}

function renderLinks(h) {
  return [ 'full', 'short' ].map(type => {
    let copyDisabled
    let copyLoading
    if (type === 'full') {
      copyDisabled = !this.fullLink
      copyLoading = false
    } else {
      copyDisabled = this.loading || !this.shortLink
      copyLoading = this.loading
    }

    return h(
      'div',
      {
        class: 'faife grid-gap--8'
      },
      [
        h(
          'div',
          {
            class: 'utm-link'
          },
          [
            h(
              tag,
              {
                props: {
                  label: this.getTranslate(`utm.labels.links.${type}`),
                  size: sizes.tiny,
                  mode: buttonModes.flat,
                  color: Colors.grey
                }
              }
            ),

            h(
              'pre',
              {
                class: 'utm-link__url'
              },
              this[`${type}Link`]
            )
          ]
        ),

        h(
          buttonCopy,
          {
            props: {
              value: this[`${type}Link`],
              disabled: copyDisabled,
              loading: copyLoading,
              tooltip: this.getTranslate('misc.buttons.copy'),
              snackbar: {
                text: this.getTranslate('misc.copied'),
                type: Colors.success
              }
            }
          }
        )
      ]
    )
  })
}

function renderDialogBody(h) {
  return h(
    'div',
    {
      class: 'grid pa-2'
    },
    [
      renderURL.call(this, h),
      renderSources.call(this, h),
      renderParams.call(this, h),
      renderLinks.call(this, h)
    ]
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'pa-2 faic fjcfe grid-gap--8',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.reset'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.setDefaultsBySource()
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 900
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        title: this.getTranslate('utm.title'),
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    button,
    {
      props: {
        iconSVG: 'utm',
        mode: buttonModes.flat,
        color: Colors.utm,
        tooltip: this.getTranslate('utm.tooltips.generate')
      },
      on: {
        click: () => {
          this.showDialog = !this.showDialog
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
